import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseBalance = async (houseId) => {
  return await request.get(
    `HousingStock/house/${houseId}/balance`,
    {},
    'При загрузке информации о задолженности дома произошла ошибка',
    {}
  );
};

const useHouseBalance = (houseId, options = {}) =>
  useQuery(getQueryKeys.houseBalance(houseId), () => getHouseBalance(houseId), {
    placeholderData: {},
    enabled: Boolean(houseId),
    ...options,
  });

export default useHouseBalance;
